import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'

import isEmpty from 'lodash/isEmpty'
import {
    noop,
} from 'lodash'
import isBoolean from 'lodash/isBoolean'

import {
    BatchActionData,
} from 'app/shared-components/TableActionsContext/TableActionsContext'
import {
    useTableActionsContext,
} from 'app/shared-components/TableActionsContext'
import useStyles from './BatchActionPopupWrapper.styles'

type Props = {
    dialogTitle?: string,
    classNames?: {
        title?: string,
        content?: string,
        paper?: string,
    },
    onClose?: () => void,
    renderChildren: (data: {
        closePopup: () => void,
        data: BatchActionData,
    }) => JSX.Element,
}

const BatchActionPopupWrapper = (
    {
        dialogTitle = 'BULK UPDATE',
        classNames = {},
        onClose = noop,
        renderChildren,
    }: Readonly<Props>,
) => {
    const {
        cx,
        classes,
    } = useStyles()

    const {
        batchActionData,
        setBatchActionData,
        invalidateTableDataRef,
    } = useTableActionsContext()

    const handleClose = () => {
        invalidateTableDataRef.current?.()
        setBatchActionData(null)
        onClose()
    }

    return (
        <Dialog
            open={batchActionData && (isBoolean(batchActionData) || !isEmpty(batchActionData))}
            classes={{
                paper: classNames.paper || classes.paper,
            }}
        >
            <DialogTitle classes={{
                root: cx(classes.title, classNames.title),
            }}
            >
                {dialogTitle.toUpperCase()}
            </DialogTitle>
            <DialogContent className={cx(classes.dialogContent, classNames.content)}>
                {renderChildren({
                    closePopup: handleClose,
                    data: batchActionData,
                })}
            </DialogContent>
        </Dialog>
    )
}

export default BatchActionPopupWrapper
